import * as React from "react";

import { Button } from "@blueprintjs/core";
import {
  captureMessage,
  configureScope,
  showReportDialog
} from "@sentry/browser";

interface IProps {
  meta?: { [key: string]: any };
}

export default class ProblemReporterButton extends React.Component<IProps> {
  public render() {
    return (
      <div>
        <Button intent="danger" small={true} onClick={this.reportProblem}>
          Report problem
        </Button>
      </div>
    );
  }

  private reportProblem = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    configureScope(scope => {
      const { meta } = this.props;

      if (meta) {
        Object.keys(meta).forEach(key => {
          scope.setExtra(key, meta[key] || "undefined");
        });
      }

      const eventId = captureMessage("User problem report");
      showReportDialog({
        eventId,
        labelComments:
          "Please describe step-by-step how to reproduce, explain what you expected to happen and tell us what happened instead",
        subtitle:
          "Before sending a report, please check with a colleague, explain how to reproduce step-by-step, and only if they can reproduce the issue report it here. If we can't reproduce the issue by following your steps, we won't follow up on your report.",
        subtitle2: "(Please do not report problems with images here)",
        title: "Report a problem with the application"
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/ProblemReporterButton.tsx